import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import Header from "./content/header"
import api from "../../services/api"


class EditcursosAdmin extends Component {

  constructor(props) {
    super(props);
   
  }

  state ={
    nome:null,
    cpf:null,
    email:null,
    telefone1:null,
    telefone2:null,
    iduser:this.props.match.params.iduser,
    aluno:[]
  }
 
  async componentDidMount(){
   

    const {iduser} = this.state;
    const response = await api.post("admin/user/id", {iduser});

    this.setState({
      aluno:response.data.success,
      nome:response.data.success.nomecompleto,
    cpf:response.data.success.cpf,
    telefone1:response.data.success.telefone1,
    telefone2:response.data.success.telefone2,
    email:response.data.success.user.email
    })

    



  }

 



 













  onFormSubmit = async e =>{
    e.preventDefault() ;

    const { email, telefone1, telefone2, nome,cpf, iduser } = this.state;
      if (!iduser, !email || !telefone1 || !cpf || !nome ) {
          this.setState({ error: "Preencha os campos antes de editar!",
        success:null });
      } else {
      const response = await api.post("/admin/user/edit", { email, telefone1, telefone2, nome,cpf, email,iduser });
       

        if(response.data.success.id){
          this.setState({ success: "Aluno Editado!" , error:null,
        });
        }

      }
  }



  render() {

    
    return (
      <React.Fragment>
          <Header />
        <div class="container col-sm-4 p-4">     

        <h4>Editar Aluno</h4>     
        <form  onSubmit={this.onFormSubmit}>
        {this.state.error && <p>{this.state.error}</p>}
        {this.state.success && <p>{this.state.success}</p>}

                <div class="form-group">
                    <label for="exampleFormControlInput1">Nome</label>
                    <input type="text" class="form-control" defaultValue={this.state.nome} onChange={e => this.setState({ nome: e.target.value })}  />
                </div>
                <div class="form-group">
                    <label for="exampleFormControlInput1">E-mail</label>
                    <input type="text" class="form-control" defaultValue={this.state.email} onChange={e => this.setState({ email: e.target.value })}  />
                </div>
                <div class="form-group">
                    <label for="exampleFormControlInput1">CPF</label>
                    <input type="text" class="form-control" defaultValue={this.state.cpf} onChange={e => this.setState({ cpf: e.target.value })}  />
                </div>
                <div class="form-group">
                    <label for="exampleFormControlInput1">Telefone 1</label>
                    <input type="text" class="form-control" defaultValue={this.state.telefone1} onChange={e => this.setState({ telefone1: e.target.value })}  />
                </div>
                <div class="form-group">
                    <label for="exampleFormControlInput1">Telefone 2</label>
                    <input type="text" class="form-control" defaultValue={this.state.telefone2} onChange={e => this.setState({ telefone2: e.target.value })}  />
                </div>
               

               
                





                <div class="form-group">
                <button class="btn btn-primary mb-2" >Atualizar Aluno</button>
 {this.state.error && <p>{this.state.error}</p>}
        {this.state.success && <p>{this.state.success}</p>}
                </div>
        </form>
















    </div>
      </React.Fragment>
       
    );
  }
}

export default withRouter(EditcursosAdmin);


// WEBPACK FOOTER //
// ./src/pages/Admin/editalunos.js